import Api from '../Utils/Axios';

export const GetPopularQuizzes = async (params) => {
    const response = await Api.get('analytics/popular-quizzes', { params });
    return response.data;
};

export const GetChatMessagesChart = async (params) => {
    const response = await Api.get('analytics/chat-messages-chart', { params });
    return response.data;
};

export const GetPubertyCountChart = async (params) => {
    const response = await Api.get('analytics/puberty-count-chart', { params });
    return response.data;
};

export const GetGuideProductChart = async (params) => {
    const response = await Api.get('analytics/guide-product-chart', { params });
    return response.data;
};

export const GetSymptomExperiencedChart = async (params) => {
    const response = await Api.get('analytics/symptom-experienced-chart', { params });
    return response.data;
};

export const GetPopularLessons = async (params) => {
    const response = await Api.get('analytics/popular-lessons', { params });
    return response.data;
};
